import {ReactElement, ReactNode} from 'react';

interface Props {
	children: ReactNode,
}

export default function FormControls({children}: Props): ReactElement {
	return (
		<div style={{display: 'flex', justifyContent: 'end', gap: 10, marginTop: 10}}>
			{children}
		</div>
	);
}
